<!--<router-outlet></router-outlet>-->
<ng-container>
  <mcresidus-layout [ngClass]="mainColor"></mcresidus-layout>
</ng-container>

<!--<ngx-guided-tour></ngx-guided-tour>-->
